<template>
  <v-row justify="center">
    <v-col class="col-6">
      <h2>{{ $lang("price") }}</h2>
    </v-col>
    <v-col class="col-6">
      <v-text-field
        type="number"
        v-model="item.vcoin"
        :label="$lang('vcoins')"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "selector-vcoin",
  props: ["item"],
  data() {
    return {};
  },
  watch: {},
  methods: {},
  created() {
    if (this.item) {
      if (!this.item.points_correct) {
        this.item.points_correct = 1;
      }
      if (!this.item.points_incorrect) {
        this.item.points_incorrect = 0;
      }
      if (!this.item.points_unattempted) {
        this.item.points_unattempted = 0;
      }
    }
  },
};
</script>